module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e1213442"
    }
  }, [_c('b', [_vm._v("BAKED RICOTTA "), _c('br'), _vm._v(" WITH TOMATO VINAIGRETTE")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e1214242"
    }
  }, [_c('b', [_c('i', [_vm._v("Once baked and allowed to set, the squares of ricotta cheese make a nice substitute for medallions of goat cheese or even polenta wedges.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1215542"
    }
  }, [_c('b', [_vm._v("Prep: 15 minutes plus standing       Bake: 1 hour")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1216042"
    }
  }, [_vm._v("2 lemons")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1216342"
    }
  }, [_vm._v("1 container (32 ounces) part-skim ricotta cheese")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1216642"
    }
  }, [_vm._v("¾ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1217542"
    }
  }, [_vm._v("⅜ teaspoon ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1218542"
    }
  }, [_vm._v("½ teaspoon Dijon mustard")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1219442"
    }
  }, [_vm._v("¼ cup olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1220442"
    }
  }, [_vm._v("4 plum tomatoes, coarsely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1220742"
    }
  }, [_vm._v("1 bag (5 to 6 ounces) baby greens")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e1221242"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" Preheat oven to 375°F. From lemons, grate 1 teaspoon peel and squeeze 3 tablespoons juice. Set aside. Spray 9-inch glass or ceramic pie plate with nonstick cooking spray.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1223142"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" In medium bowl, stir lemon peel, ricotta, ½ teaspoon salt, and ¼ teaspoon pepper until blended. Spread ricotta mixture evenly in prepared pie plate. Bake 1 hour or until cheese is lightly browned. Let stand 10 minutes to allow cheese to set. Slice into 12 wedges.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1227542"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Meanwhile, in medium bowl, whisk together lemon juice, Dijon, ¼ teaspoon salt, and ⅛ teaspoon pepper. Whisk in olive oil in slow steady stream until blended. Stir in chopped tomatoes.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1230942"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("4.")])]), _vm._v(" To serve, place 1 ricotta wedge along with some greens on each of 12 serving plates. Top greens and ricotta with tomato vinaigrette. Makes 12 first-course servings.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e1232942"
    }
  }, [_vm._v("Each serving: About 155 calories, 9g protein, 6g carbohydrate, 11g total fat (4g saturated), 1g fiber, 23mg cholesterol, 245mg sodium.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781618371621_0042_001",
      "src": "Images/9781618371621_0042_001.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap",
    attrs: {
      "id": "d7e1234142"
    }
  }, [_c('i', [_vm._v("Baked Ricotta with Tomato Vinaigrette")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66a0743a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c31_r1.vue
// module id = 159
// module chunks = 0